import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import {
  addCrossSellDisplayed,
  crossSellingModuleDisplayedTracked,
  getCrossSellDisplayed,
} from 'domains/crossSelling/CrossSelling.store';
import { CrossSellingContextType } from 'domains/crossSelling/CrossSelling.types';
import { getTokenUser } from 'domains/user';

export const useCrossSellingModuleDisplayed = (
  mainReferenceNumber: string,
  mainReferenceFamilyCode: string | undefined,
  vin: string | undefined,
  mainReferenceSegmentMarketing: string | undefined,
  contextType: CrossSellingContextType,
  location: 'product' | 'catalog',
  numberOfItemsInModule: number,
) => {
  const dispatch = useDispatch();
  const tokenUser = useSelector(getTokenUser);
  const crossSellDisplayed = useSelector((state: RootState) => getCrossSellDisplayed(state, tokenUser?.id ?? ''));
  const displayedModuleKey = `${mainReferenceNumber}::${contextType}::${location}`;

  useEffect(() => {
    if (tokenUser && !crossSellDisplayed.has(displayedModuleKey)) {
      // Deduplicate by module source ref so one visible module yields one DISPLAY event.
      dispatch(
        addCrossSellDisplayed({
          userId: tokenUser.id,
          crossSellRef: mainReferenceNumber,
          contextType,
          location,
        }),
      );
      dispatch(
        crossSellingModuleDisplayedTracked({
          mainReferenceNumber,
          mainReferenceFamilyCode,
          vin,
          mainReferenceSegmentMarketing,
          contextType,
          location,
          numberOfItemsInModule,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    contextType,
    crossSellDisplayed,
    displayedModuleKey,
    dispatch,
    location,
    mainReferenceFamilyCode,
    mainReferenceNumber,
    vin,
    mainReferenceSegmentMarketing,
    numberOfItemsInModule,
    tokenUser,
  ]);
};
